import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { MP_CLICKED_PACKAGE_SELECT } from '../../../utils/mixPanelEvents';
import { BQ_CLICKED_PACKAGE_SELECT } from '../../../utils/bigQueryEvents';
import sendGraphiteEvent from '../../../utils/sendGraphiteEvent';
import { ORDER_NOW_BUTTON_CLICKS } from '../../../utils/sendGraphiteEvent/events';
import { isSinglePackage } from '../../../reducers/packages';

class CheckoutFormHOC extends Component {

    constructor() {
        super();

        this.state = {
            inProgress: false
        };

        this.onSubmit = this.onSubmit.bind(this);
    }

    reportBI() {
        const { selectedPackageId, source } = this.props;
        const { biEvents } = this.context;
        const eventParams = {
            id: selectedPackageId,
            source
        };

        biEvents.sendMixPanelEvent({eventName: MP_CLICKED_PACKAGE_SELECT, params: eventParams});
        biEvents.sendBigQueryEvent({eventName: BQ_CLICKED_PACKAGE_SELECT, params: eventParams});
        sendGraphiteEvent(ORDER_NOW_BUTTON_CLICKS);
    }

    onSubmit() {
        this.setState({inProgress: true});
        this.reportBI();
    }

    isFiverrChoice() {
        const { requestContext, general } = this.context;
        const { isFiverrChoice } = general;
        const { fiverr_choice: fiverrChoice } = requestContext.params;

        return isFiverrChoice && fiverrChoice;
    }

    render() {
        const {
            selectedPackageId,
            children,
            isSingle,
            quantity,
            className
        } = this.props;

        const { pathfinderWrapper, general, requestContext } = this.context;
        const { gigId } = general;
        const { csrf_token: csrfToken, is_mobile: isMobile } = requestContext;
        const { inProgress } = this.state;
        const isFiverrChoice = this.isFiverrChoice();

        const formAction = isMobile ? 'checkout_package' : 'checkout_customize';

        return (
            <form className={className} action={`${pathfinderWrapper.pathfinder(formAction, {gig_id: gigId})}`} method="post" onSubmit={this.onSubmit} >
                <input type="hidden" name="authenticity_token" value={csrfToken}/>
                <input type="hidden" name="packages[gig_id]" value={gigId}/>
                <input type="hidden" name="packages[package_id]" value={selectedPackageId}/>
                <input type="hidden" name="fiverr_choice" value={isFiverrChoice}/>
                {/* Single package specific form field */}
                {isSingle &&
                <div>
                    <input type="hidden" name="gig_id" value={gigId}/>
                    <input type="hidden" name="quantity" value={quantity}/>
                </div>
                }
                {
                    React.Children.map(children, (child) => {
                        if (child !== null) {
                            return React.cloneElement(child, { inProgress });
                        }
                    })
                }
            </form>
        );
    }
}

const mapStateToProps = ({ packages }, ownProps) => ({
    selectedPackageId: ownProps.selectedPackageId,
    source: ownProps.source,
    className: ownProps.className,
    isSingle: isSinglePackage(packages),
    quantity: packages.quantity
});

CheckoutFormHOC.propTypes = {
    selectedPackageId: PropTypes.number.isRequired,
    source: PropTypes.string.isRequired,
    isSingle: PropTypes.bool,
    quantity: PropTypes.number,
    className: PropTypes.string
};

CheckoutFormHOC.contextTypes = {
    biEvents: PropTypes.object,
    pathfinderWrapper: PropTypes.object,
    general: PropTypes.object,
    requestContext: PropTypes.object
};

export { CheckoutFormHOC };

export default connect(mapStateToProps)(CheckoutFormHOC);
